import './bootstrap';


document.addEventListener('DOMContentLoaded', () => {

    const sidebar = document.getElementById('sidebar');
    const toggle = document.getElementById('menu-toggle');
    const overlay = document.getElementById('sidebar-overlay');
    if (toggle && sidebar && overlay) {
        const open = () => {
            sidebar.classList.remove('translate-x-full');
            overlay.classList.remove('hidden');
        };
        const close = () => {
            sidebar.classList.add('translate-x-full');
            overlay.classList.add('hidden');
        };
        toggle.addEventListener('click', () => {
            if (sidebar.classList.contains('translate-x-full')) {
                open();
            } else {
                close();
            }
        });
        overlay.addEventListener('click', close);
    }

    const userBtn = document.getElementById('user-menu-button');
    const userMenu = document.getElementById('user-menu');
    if (userBtn && userMenu) {
        userBtn.addEventListener('click', () => {
            userMenu.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
            if (!userBtn.contains(e.target) && !userMenu.contains(e.target)) {
                userMenu.classList.add('hidden');
            }
        });
    }

    const selectAll = document.getElementById('select-all');
    if (selectAll) {
        const container = selectAll.closest('form') || document;
        const checkboxes = container.querySelectorAll('input[name="ids[]"]');
        const bulkBtn = container.querySelector('#bulk-action-btn');
        const refresh = () => {
            const checked = container.querySelectorAll('input[name="ids[]"]:checked').length;
            if (bulkBtn) bulkBtn.classList.toggle('hidden', checked === 0);
            selectAll.indeterminate = checked > 0 && checked < checkboxes.length;
            selectAll.checked = checked === checkboxes.length;
        };
        selectAll.addEventListener('change', () => {
            checkboxes.forEach(cb => cb.checked = selectAll.checked);
            refresh();
        });
        checkboxes.forEach(cb => cb.addEventListener('change', refresh));
        refresh();
    }

    document.querySelectorAll('.column-toggle').forEach(cb => {
        const update = () => {
            document.querySelectorAll(cb.dataset.column).forEach(el => {
                el.classList.toggle('d-none', !cb.checked);
            });
        };
        cb.addEventListener('change', update);
        update();
    });

    document.querySelectorAll('[data-toggle-password]').forEach(btn => {
        const target = document.getElementById(btn.dataset.target);
        if (!target) return;
        btn.addEventListener('click', () => {
            const type = target.getAttribute('type') === 'password' ? 'text' : 'password';
            target.setAttribute('type', type);
            btn.textContent = type === 'password' ? 'إظهار' : 'إخفاء';
        });
    });

    document.querySelectorAll('.account-refresh-form').forEach(form => {
        const button = form.querySelector('.account-refresh-btn');
        const icon = button?.querySelector('.refresh-icon');
        const spinner = button?.querySelector('.loading-spinner');
        if (!button) return;
        form.addEventListener('submit', () => {
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
            if (icon) icon.classList.add('d-none');
            if (spinner) spinner.classList.remove('d-none');
        }, { once: true });
    });
});

